import { Box, Typography } from '@mui/material';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';

const styles: IStyles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(5), md: pxTovW(8) },
    padding: {
      xs: `${pxToRem(5)} ${pxToRem(13)}`,
      md: `${pxTovW(7)} ${pxTovW(11)}`,
    },
    borderRadius: {
      xs: pxToRem(16),
      md: pxTovW(35),
    },
    border: '1px solid #FFD966',
    backgroundColor: 'common.white',
    width: 'fit-content',
    marginLeft: '5px',
  },
  dot: {
    width: { xs: pxToRem(8), md: pxTovW(10) },
    height: { xs: pxToRem(8), md: pxTovW(10) },
    borderRadius: '50%',
    backgroundColor: '#0AA34F',
    flexShrink: 0,
  },
  label: {
    fontWeight: 700,
  },
};

export const PreviouslyUsedTag = () => {
  return (
    <Box sx={styles.root}>
      <Box sx={styles.dot} />
      <Typography
        variant="elementSmallText"
        fontFamily="Poppins"
        sx={styles.label}
      >
        Previously Used
      </Typography>
    </Box>
  );
};
